// @ts-nocheck

export const OverlayStateActionTypes = Object.freeze({
  PLAY_ANIMATION: 'OVERLAY:PLAY_ANIMATION',
  STOP_ANIMATION: 'OVERLAY:STOP_ANIMATION',
});
